const actions = {
  LIST_COUNTRIES_BEGIN: "LIST_COUNTRIES_BEGIN",
  LIST_COUNTRIES_SUCCESS: "LIST_COUNTRIES_SUCCESS",
  LIST_COUNTRIES_ERR: "LIST_COUNTRIES_ERR",

  CREATE_COUNTRY_BEGIN: "CREATE_COUNTRY_BEGIN",
  CREATE_COUNTRY_SUCCESS: "CREATE_COUNTRY_SUCCESS",
  CREATE_COUNTRY_ERR: "CREATE_COUNTRY_ERR",

  listCountriesBegin: () => {
    return {
      type: actions.LIST_COUNTRIES_BEGIN,
    };
  },

  listCountriesSuccess: (data) => {
    return {
      type: actions.LIST_COUNTRIES_SUCCESS,
      data,
    };
  },

  listCountriesErr: (err) => {
    return {
      type: actions.LIST_COUNTRIES_ERR,
      err,
    };
  },

  createCountryBegin: () => {
    return {
      type: actions.CREATE_COUNTRY_BEGIN,
    };
  },

  createCountrySuccess: (data) => {
    return {
      type: actions.CREATE_COUNTRY_SUCCESS,
      data,
    };
  },

  createCountryErr: (err) => {
    return {
      type: actions.CREATE_COUNTRY_ERR,
      err,
    };
  },
};

export default actions;
